<template>
  <div class="example-fills">
    <div class="section-title">Example fills</div>
    <ul class="rows">
      <li v-for="row in computedRows" :key="row.key" class="row">
        <span class="label">{{ row.label }} &mdash; {{ row.cylinderSize }}L @ 230 bar</span>
        <span v-if="row.total !== null" class="total">{{ currency }} {{ formatPrice(row.total) }}</span>
        <span v-else class="missing">
          &mdash;
          <span class="hint">{{ row.hint }}</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { blendLitres } from './blendLitres'

const EXAMPLES = [
  { key: 'air-12', label: 'Air', o2: 21, he: 0, cylinderSize: 12 },
  { key: 'air-15', label: 'Air', o2: 21, he: 0, cylinderSize: 15 },
  { key: 'nx32-12', label: 'Nitrox 32', o2: 32, he: 0, cylinderSize: 12 },
  { key: 'nx32-15', label: 'Nitrox 32', o2: 32, he: 0, cylinderSize: 15 }
]
const FILL_PRESSURE = 230

export default {
  name: 'ExampleFills',
  props: {
    components: {
      type: Object,
      required: true
    },
    currency: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    computedRows () {
      return EXAMPLES.map(spec => {
        const litres = blendLitres({
          o2Pct: spec.o2,
          hePct: spec.he,
          cylinderSize: spec.cylinderSize,
          fillPressure: FILL_PRESSURE
        })
        if (!litres) {
          return { ...spec, total: null, hint: 'invalid mix' }
        }
        const missing = this.missingComponent(litres)
        if (missing) {
          return { ...spec, total: null, hint: `${missing} price not configured` }
        }
        const total =
          litres.air * (this.components.air || 0) +
          litres.o2 * (this.components.o2 || 0) +
          litres.he * (this.components.he || 0)
        return { ...spec, total }
      })
    }
  },
  methods: {
    missingComponent (litres) {
      if (litres.air > 0 && this.components.air === null) return 'Air'
      if (litres.o2 > 0 && this.components.o2 === null) return 'O2'
      if (litres.he > 0 && this.components.he === null) return 'Helium'
      return null
    },
    formatPrice (value) {
      const n = Number(value)
      if (!Number.isFinite(n)) return '—'
      return n.toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
  .section-title {
    font-size: 12px;
    text-transform: uppercase;
    color: $text-light;
    margin-bottom: 10px;
  }

  .rows {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 6px 0;

    .label {
      font-size: 13px;
    }

    .total {
      font-variant-numeric: tabular-nums;
      font-weight: 500;
    }

    .missing {
      font-size: 13px;
      color: $text-light;

      .hint {
        margin-left: 6px;
        font-size: 11px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Pricing/ExampleFills.vue